import { Directive } from '@angular/core';
import {
  ConsentType,
  ILegalTexts,
  ITheme,
  WhitelabelImage,
  WhitelabelImageType,
} from '../../models';
import { Store } from '@ngrx/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map, switchMap, take } from 'rxjs/operators';
import {
  getConsentSetActionState,
  getLegalTexts,
  getLegalTextsActionState,
  getTheme,
  LoadLegalTexts,
  SetConsent,
} from '../../+state';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { IActionState } from '../../utils';
import { LegalType } from '../../models/account/legal-type.enum';

@UntilDestroy()
@Directive()
export abstract class ChatBotConsentBaseComponent {
  public whitelabelImage = WhitelabelImage;
  public whitelabelImageType = WhitelabelImageType;
  public legalTexts$: Observable<ILegalTexts>;
  public legalTextsState$: Observable<IActionState>;
  public legalType = LegalType;

  public theme: ITheme;

  public fg: FormGroup = this.fb.group({
    consent: [false, [Validators.requiredTrue]],
  });
  constructor(
    protected store: Store,
    protected fb: FormBuilder
  ) {
    this.store.dispatch(LoadLegalTexts());
    this.store
      .select(getTheme)
      .pipe(
        filter(theme => theme !== null),
        untilDestroyed(this)
      )
      .subscribe(theme => {
        this.theme = theme;
      });

    this.legalTextsState$ = this.store.select(getLegalTextsActionState);
    this.legalTexts$ = this.store.select(getLegalTexts).pipe(
      filter(legalTexts => !!legalTexts),
      map(legalTexts => legalTexts)
    );
  }

  setChatBotConsent() {
    return this.legalTexts$.pipe(
      filter(legalTexts => !!legalTexts),
      take(1),
      map(legalTexts => {
        this.store.dispatch(
          SetConsent({
            consentType: ConsentType.CHATBOT_USAGE,
            consentId: legalTexts.chatbotUsageId,
            consentGiven: true,
          })
        );
      }),
      switchMap(() => this.store.select(getConsentSetActionState)),
      filter(state => state.done),
      take(1)
    );
  }
}
